import axios from 'axios';
import { encryptIt } from './common';

export async function submitForm(formValues) {
    var form_data = new FormData();

    console.log(formValues)

    for (var i = 0; i < formValues.formBOs.length; i++) {
        console.log(formValues.formBOs[i].boAddressProof, 'zzzzz');
        for (var j = 0; j < formValues.formBOs[i].boNICProof.length; j++) {
            form_data.append(`NIC${j}`, formValues.formBOs[i].boNICProof[j].originFileObj, formValues.formBOs[i].key)
        }
        for (var j = 0; j < formValues.formBOs[i].boAddressProof.length; j++) {
            form_data.append(`proofAddress${j}`, formValues.formBOs[i].boAddressProof[j].originFileObj, formValues.formBOs[i].key)
        }
    }

    
    form_data.append('data', await encryptIt(formValues))
    console.log(form_data, 'FORM DATA')

    let isFormSubmitted = await axios({
        method: 'POST',
        url: process.env.REACT_APP_API + '/api/create/bo/',
        // headers: {
        //     'Content-Type': 'multipart/form-data'
        // },
        data: form_data
        // data: {
        //     data: await encryptIt(formValues),
        //     attachments: form_data
        // }
    })
    return isFormSubmitted.data
}